export enum SdEvents {
    CalculateStart = 'drPaymentCalcStart',
    CalculateComplete = 'drPaymentCalcFinish',
    ProtectionsComplete = 'drFiFinish',
    FormStart = 'drLeadFormStart',
    FormComplete = 'drLeadFormFinish',
    TradeInComplete = 'drTradeInEval',
    TestDriveScheduledComplete = 'drApptSched',
    LoadPrecisePrice = 'drInitialClick'
}
